export default "__VITE_ASSET__BuyTCRsx__"